import { createSlice } from "@reduxjs/toolkit";


const companySchemesSlice = createSlice({
    name: "companySchemes",
    initialState: {
        selectedScheme: null
    },
    reducers: {
        setSelectedScheme: (state, action) => {
            state.selectedScheme = action.payload;
        }
    }
});

export const { setSelectedScheme } = companySchemesSlice.actions;
export default companySchemesSlice.reducer;